import { useState, useEffect, useRef } from "react";
import "./scroll-up-button.scss";

export default function ScrollUpButton() {
  const CARAT_ICON = `${process.env.PUBLIC_URL}/images/icons/carat.svg`;
  const [visible, setVisible] = useState(false);
  const btnRef = useRef(null);
  const scrollElRef = useRef(null);

  useEffect(() => {
    const root = document.getElementById("root");

    // Decide which element actually scrolls
    const scrollElement =
      root && root.scrollHeight > root.clientHeight ? root : window;

    scrollElRef.current = scrollElement;

    const handleScroll = () => {
      const scrollTop =
        scrollElement === window
          ? window.pageYOffset || document.documentElement.scrollTop || 0
          : scrollElement.scrollTop;

      setVisible(scrollTop > 100);

      if (btnRef.current) {
        btnRef.current.classList.toggle("visible", scrollTop > 300);
      }
    };

    scrollElement.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => scrollElement.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    const el = scrollElRef.current;

    if (!el) return;

    if (el === window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      el.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <button
      ref={btnRef}
      className={`scroll-up-button margin-right-2 ${visible ? "visible" : ""}`}
      onClick={scrollToTop}
    >
      <img src={CARAT_ICON} alt="Up" width="30" height="30" />
    </button>
  );
}
